import { render, staticRenderFns } from "./ProdesAmazonia.vue?vue&type=template&id=de87f252&lang=pug"
import script from "./ProdesAmazonia.vue?vue&type=script&lang=js"
export * from "./ProdesAmazonia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports